import { render, staticRenderFns } from "./LmInboxListbuilder.vue?vue&type=template&id=180e4b02"
import script from "./LmInboxListbuilder.vue?vue&type=script&lang=js"
export * from "./LmInboxListbuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports